(() => {
  'use strict';
  const bags = new Set([55119708160327, 55119708193095, 55119708225863]);
  const protection = 55120890429767, priority = 55120890462535;
  const returns60 = 55119757410631, returns90 = 55119757443399;
  const benefits = new Set([protection, priority, returns60, returns90]);
  const root = window.Shopify?.routes?.root || '/';
  const send = window.fetch.bind(window);
  let queue = Promise.resolve();
  let allowCheckout = false;
  const getCart = () => send(root + 'cart.js', {cache: 'no-store'}).then(r => {
    if (!r.ok) throw new Error('Please refresh your cart before checking out.');
    return r.json();
  });
  const countBags = cart => cart.items.reduce((n, item) => n + (bags.has(item.variant_id) ? item.quantity : 0), 0);
  const freeItems = cart => new Set(cart.items.filter(i => benefits.has(i.variant_id) && i.final_line_price === 0).map(i => i.variant_id));
  async function clean(cart, before) {
    const count = countBags(cart), updates = {}, used = new Set();
    const previouslyFree = freeItems(before || cart);
    const has90 = cart.items.some(i => i.variant_id === returns90);
    for (const item of cart.items) {
      const id = item.variant_id;
      if (!benefits.has(id)) continue;
      const wasGift = previouslyFree.has(id) || Object.entries(item.properties || {}).some(([k, v]) => /gift/i.test(k) && (v === true || v === 'true'));
      let eligible = count > 0;
      if (id === returns60) eligible = count === 2 && !has90;
      if (wasGift && id === protection) eligible = count >= 2;
      if (wasGift && (id === priority || id === returns90)) eligible = count >= 3;
      const quantity = eligible && !used.has(id) ? 1 : 0;
      used.add(id);
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    if (!Object.keys(updates).length) return {cart, changed:false};
    const response = await send(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates})});
    if (!response.ok) throw new Error('Please refresh your cart before checking out.');
    return {cart:await response.json(), changed:true};
  }
  async function requestedItems(input, init) {
    let body = init?.body;
    if (!body && input instanceof Request) body = await input.clone().text();
    if (body instanceof FormData || body instanceof URLSearchParams) {
      return body.has('id') ? [{id:Number(body.get('id')),quantity:Number(body.get('quantity') || 1)}] : [];
    }
    if (typeof body !== 'string') return [];
    try { const value=JSON.parse(body); return value.items || (value.id ? [value] : []); }
    catch { const params=new URLSearchParams(body); return params.has('id') ? [{id:Number(params.get('id')),quantity:Number(params.get('quantity') || 1)}] : []; }
  }
  function announce(message) {
    let node=document.getElementById('pupmigo-cart-message');
    if (!node) {node=document.createElement('p');node.id='pupmigo-cart-message';node.setAttribute('role','alert');node.style.cssText='padding:12px;background:#fff8f0;color:#352823;text-align:center';document.querySelector('main')?.prepend(node);}
    node.textContent=message;
  }
  window.fetch = function(input, init) {
    const url = new URL(typeof input === 'string' ? input : input.url, location.origin);
    if (url.origin !== location.origin || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) return send(input, init);
    const work = async () => {
      const before = await getCart();
      if (/\/add(\.js)?$/.test(url.pathname)) {
        const added = await requestedItems(input, init);
        if (added.some(i=>benefits.has(Number(i.id))) && !countBags(before) && !added.some(i=>bags.has(Number(i.id)) && Number(i.quantity || 1)>0)) {
          return new Response(JSON.stringify({status:422,message:'Add a Pupmigo backpack first.',description:'These extras are available only with a Pupmigo backpack.'}), {status:422,headers:{'Content-Type':'application/json'}});
        }
      }
      const response=await send(input,init);
      if (!response.ok) return response;
      const result=await clean(await getCart(),before);
      if (!result.changed) return response;
      let payload;
      try {payload=await response.clone().json();} catch {return response;}
      if (payload.sections) {
        const keys=Object.keys(payload.sections);
        const html=await send(root+'?sections='+encodeURIComponent(keys.join(','))).then(r=>r.json());
        payload.sections=html;
      }
      if (!/\/add(\.js)?$/.test(url.pathname)) payload={...result.cart,sections:payload.sections};
      return new Response(JSON.stringify(payload),{status:response.status,headers:response.headers});
    };
    const result=queue.then(work,work);queue=result.catch(()=>{});return result;
  };
  document.addEventListener('submit', event => {
    const form=event.target;
    if (!form.matches('form')) return;
    if (form.action.includes('/cart/add') && benefits.has(Number(new FormData(form).get('id')))) {
      event.preventDefault();event.stopImmediatePropagation();announce('Choose your extras with a Pupmigo backpack on the product page.');
    }
    if (event.submitter?.name === 'checkout' && !allowCheckout) {
      event.preventDefault();event.stopImmediatePropagation();checkout();
    }
  },true);
  async function checkout() {
    try {
      await queue;
      const result=await clean(await getCart());
      if (!countBags(result.cart)) {announce('Add a Pupmigo backpack before checking out.');location.assign(root+'cart');return;}
      allowCheckout=true;location.assign(root+'checkout');
    } catch(error) {announce(error.message);}
  }
  document.addEventListener('click', event => {
    const target=event.target.closest('button[name="checkout"],input[name="checkout"],a[href*="/checkout"]');
    if (target && !allowCheckout) {event.preventDefault();event.stopImmediatePropagation();checkout();}
  },true);
  document.addEventListener('DOMContentLoaded',async()=>{
    try {
      const result=await clean(await getCart());
      if(result.changed && /\/cart\/?$/.test(location.pathname)) location.reload();
    } catch(error) {console.warn('Pupmigo cart check:',error.message);}
  });
})();
